<template>
  <div class="bg-purple of">
    <el-form label-width="150px">
      <el-row>
        <panel title="客户信息" border>
          <el-col :span="12">
            <el-form-item label="客户编号：">
              {{creditData.u__customerCode}}
            </el-form-item>
            <el-form-item label="客户姓名：">
              {{creditData.u__customerName}}
            </el-form-item>
            <el-form-item label="建档时间：">
              {{creditData.u__createdDate|moment('YYYY-MM-DD')}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="性别：">
              {{creditData.i__contactSex|sex2CN }}
            </el-form-item>
            <el-form-item label="身份证号码：">
              {{creditData.i__bizrepIC}}
            </el-form-item>
            <el-form-item label="手机号：">
              {{creditData.i__contactTelNo}}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="常住地址：">
              {{creditData.i__province}}&nbsp;{{creditData.i__city}} {{creditData.i__address}}
            </el-form-item>
           </el-col>
          <el-col :span="24">
            <el-form-item label="客户获取渠道：">
              {{creditData.c__customerName}}
            </el-form-item>
          </el-col>
        </panel>
        <panel title="授信信息" border>
          <el-col :span="24">
            <el-form-item label="贷款产品：">
              {{creditData.p__productName}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="授信类型：">
              {{creditData.cr__creditType}}
            </el-form-item>
            <el-form-item label="授信起始日：">
              {{creditData.cr__creditValidity1}}
            </el-form-item>
            <el-form-item label="贷款比例：">
              {{creditData.cr__financingRatio}} %
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="授信额度：">
              {{creditData.cr__lineOfCredit|formatMoney}} 元
            </el-form-item>
            <el-form-item label="授信到期日：">
              {{creditData.cr__creditValidity2}}
            </el-form-item>
            <el-form-item label="贷款阈值：">
              {{creditData.cr__threshold|formatMoney}} 元
            </el-form-item>
          </el-col>

        </panel>
      </el-row>
    </el-form>
   <!-- <el-form label-width="150px">
      <el-row>
        <panel title="融资产品信息" border>
          <el-col :span="12">
            <el-form-item label="产品名称：">
              {{creditData.p__productName}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="产品编号：">
              {{creditData.p__productCode}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="产品利率：">
              {{creditData.p__interestRate}} %
              ({{creditData.p__interestType|Status2CN}})
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="服务费：">
              {{creditData.p__lendingFee}}
              {{creditData.p__lendingFeeType == 'Rate' ? '%' : '元'}}
              (按 {{creditData.p__lendingFeeType|Status2CN}} 收取)
            </el-form-item>
          </el-col>
        </panel>
      </el-row>
    </el-form>-->
    <panel title="附件列表">
      <files-data-table :files.sync="creditData.files"></files-data-table>
    </panel>
    <button-back></button-back>
  </div>
</template>

<script>
  import Panel from '../../components/Panel'
  import CustomerSummary from './CustomerSummary'
  import ButtonBack from '../../components/ButtonBack'
  import FilesDataTable from '../../components/FilesDataTable'
  import sexOptions from '../../utils/sexOptions'
  import Status2CN from '../../filters/Status2CN'

  export default {
    name: "CreditDetailComponent",
    props: {
      creditData: {
        type: Object,
        default: ()=>{
          return {
            files: []
          }
        }
      }
    },
    components: {
      Panel,
      ButtonBack,
      FilesDataTable,
      CustomerSummary
    },
    filters:{
      sex2CN: function (sex) {
        let sexItem = sexOptions.filter(item=>item.value == sex).shift()||[]
        return sexItem.label||''
      },
      Status2CN
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/components/CreditDetailComponent.vue